export enum RequisitionGroupSelection {
    ALL = 'all',
    MAIN = 'main',
    MINOR = 'minor',
    CUSTOM = 'custom',
}
